import { NotificationCommunity } from "./notificationcommunity";
import { NotificationSubGroup } from "./notificationsubgroup";

export class TodaysScheduleUserCommunity {
    public todaysScheduleUserCommunityID: number;
    public edhMarketId: number;
    public edhFinancialCommunityID: number;
    public adIntegrationKey: string;
    public createdUtcDate: Date;
}